
import { isSameDay } from "date-fns";
import { CalendarEvent } from "@/hooks/calendar/types";

export const useTimeSlotEvents = (events: CalendarEvent[] = []) => {
  const getEventsForDateAndHour = (date: Date, hour: number) => {
    return events.filter(event => isSameDay(event.date, date) && event.hour === hour);
  };

  return {
    getEventsForDateAndHour
  };
};
